var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0203 4.32617H10.364V5.90245H13.0203C13.8106 5.90245 14.4235 6.30571 14.4235 6.65302V13.643C14.4235 13.9901 13.8106 14.3939 13.0203 14.3939H2.97916C2.18919 14.3939 1.57628 13.9901 1.57628 13.643V6.65381C1.57628 6.3065 2.18919 5.90297 2.97916 5.90297H5.63519V4.3267H2.97916C1.30857 4.3267 0 5.34891 0 6.65381V13.6433C0 14.9484 1.30857 15.9701 2.97916 15.9701H13.0208C14.6909 15.9701 16 14.9479 16 13.6433V6.65381C15.9997 5.34839 14.6912 4.32617 13.0203 4.32617Z",
    fill: "#3FB9E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3848 7.62024C10.1831 7.62024 9.98156 7.69747 9.82761 7.85142L8.84086 8.83791V5.41555V3.83927V0.819389C8.84086 0.384336 8.48804 0.03125 8.05272 0.03125C7.61741 0.03125 7.26458 0.384336 7.26458 0.819389V3.83901V5.41529V8.89098L6.2245 7.85116C6.07055 7.69721 5.86879 7.61997 5.66729 7.61997C5.46579 7.61997 5.26402 7.69721 5.11007 7.85116C4.80218 8.15854 4.80218 8.65769 5.11007 8.96533L7.46319 11.3184C7.61714 11.4724 7.81891 11.5488 8.02014 11.5488C8.02225 11.5488 8.02435 11.5488 8.02619 11.5488C8.02803 11.5488 8.03013 11.5488 8.03197 11.5488C8.23373 11.5488 8.43497 11.4724 8.58892 11.3184L10.942 8.96533C11.2499 8.65769 11.2499 8.15854 10.942 7.85116C10.7881 7.69747 10.5868 7.62024 10.3848 7.62024Z",
    fill: "#3FB9E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.8844bdf0a4abe3975df5f5eb8d0f0152.svg";
export { ForwardRef as ReactComponent };